import { render, staticRenderFns } from "./goods-physical-detail.vue?vue&type=template&id=49746828"
import script from "./goods-physical-detail.vue?vue&type=script&lang=js"
export * from "./goods-physical-detail.vue?vue&type=script&lang=js"
import style0 from "./goods-physical-detail.vue?vue&type=style&index=0&id=49746828&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports